module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI3NTAwNTE5ZGUzZDgyZTMzZDE1ODdmODA0MmUyYWZjYi53b2ZmIjs="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Thin.woff
// module id = 455
// module chunks = 0